<div class="text-container">

  <h1>Map AI Data Sources</h1>

  <div class="preamble">
    <p>
      We've been building location intelligence since 2016, starting at
      <a href="https://www.ticon.co/" target="_blank" rel="noopener">Ticon</a>.
      In {{ yearsOfExperience }} years we've built deep expertise reading
      traffic and demographic data to judge a location before you commit to it.
    </p>
    <p>
      Our analysis combines official government datasets, open-source
      geographic information, and Ticon's proprietary traffic intelligence.
    </p>
  </div>

  <ng-container *ngFor="let text of dataSourcesService.dataSourcesText; let i = index" >
    <mat-expansion-panel [expanded]="dataSourcesService.activeButtons.includes(text[0])">
      <mat-expansion-panel-header  (click)="dataSourcesService.updateActiveButton(text[0])">
        <mat-panel-title class="text-content-title" [ngClass]="dataSourcesService.activeButtons.includes(text[0]) ? 'title-active' : ''">
          {{text[0]}}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <!-- A div: the text holds <p>s, which a <p> cannot contain in static HTML -->
      <div class="text-content" [innerHTML]="text[1]"></div>
    </mat-expansion-panel>
    <mat-divider *ngIf="i < dataSourcesService.dataSourcesText.length - 1"></mat-divider>
  </ng-container>
</div>
